<template>
  <Layout>
    <v-row>
      <v-col class="d-flex justify-start">
        <v-btn
          elevation="2"
          @click="$router.push({ name: 'Dashboard' })"
        >
          ย้อนกลับ
        </v-btn>
      </v-col>
    </v-row>
    <br />
    <v-card elevation="2" outlined shaped tile class="px-2 py-2">
      <v-card-title>สร้างรายการนับสินค้า</v-card-title>
      <v-form v-model="valid" @submit.prevent="submit">
        <v-container>
          <v-row>
            <v-col cols="12" lg="8">
              <v-text-field
                v-model="jobName"
                :counter="100"
                label="ชื่องาน"
                required
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="heading-form">วัน-เวลาในการนับสินค้า</div>
          <v-row>
            <v-col cols="12" lg="8">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="dates"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-combobox
                    v-model="dates"
                    v-bind="attrs"
                    v-on="on"
                    multiple
                    chips
                    hide-selected
                    label="วันที่"
                    readonly
                    outlined
                    hide-details
                  >
                    <template v-slot:prepend>
                      <v-icon class="mr-2" color="primary">
                        mdi-calendar
                      </v-icon>
                    </template>
                    <template
                      v-slot:selection="{
                        attrs,
                        item,
                        select,
                        selected,
                      }"
                    >
                      <v-chip
                        v-bind="attrs"
                        :input-value="selected"
                        close
                        @click="select"
                        @click:close="remove(item)"
                      >
                        <strong>{{ item }}</strong>
                      </v-chip>
                    </template>
                  </v-combobox>
                </template>
                <v-date-picker v-model="dates" multiple>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal = false">
                    ยกเลิก
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog.save(dates)"
                  >
                    ตกลง
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row align="center" class="mb-2">
            <v-col cols="12" lg="8">
              <v-row align="center">
                <v-col cols="5" sm="2">
                  <v-select
                    v-model="fromHH"
                    :items="hours"
                    label="ชั่วโมง"
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="5" sm="2">
                  <v-select
                    v-model="fromMM"
                    :items="minutes"
                    label="นาที"
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="auto" sm="1" class="mb-sm-4">
                  ถึง
                </v-col>
                <v-col cols="5" sm="2">
                  <v-select
                    v-model="endHH"
                    :items="hours2"
                    label="ชั่วโมง"
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="5" sm="2">
                  <v-select
                    v-model="endMM"
                    :items="minutes"
                    label="นาที"
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <div class="heading-form">เลือก BU (Business Unit)</div>
          <v-row>
            <v-col cols="12" lg="8">
              <v-select
                @change="onChangeBU"
                v-model="selectBU"
                :items="bu"
                label="เลือก BU"
                item-text="bu_name"
                item-value="bu_id"
                outlined
                hide-details
              ></v-select>
            </v-col>
          </v-row>

          <div class="heading-form">เลือกสาขา</div>
          <v-row>
            <v-col cols="12" lg="8">
              <div class="select-container">
                <v-autocomplete
                  v-model="selectStore"
                  :items="storeDataFilterByBuId"
                  chips
                  label="สาขา"
                  item-text="store_name"
                  item-value="store_id"
                  multiple
                  outlined
                  small-chips
                  hide-details
                >
                  <template
                    v-if="storeDataFilterByBuId.length > 0"
                    v-slot:prepend-item
                  >
                    <v-list-item>
                      <v-list-item-title>
                        <v-checkbox
                          :label="`เลือกสาขาทั้งหมด (${storeDataFilterByBuId.length} สาขา)`"
                          :value="
                            selectStore.length ===
                            storeDataFilterByBuId.length
                          "
                          :indeterminate="
                            selectStore.length > 0 &&
                            selectStore.length <
                              storeDataFilterByBuId.length
                          "
                          class="my-0"
                          hide-details
                          @click.stop="
                            selectStore =
                              selectStore.length ===
                              storeDataFilterByBuId.length
                                ? []
                                : storeDataFilterByBuId.map(
                                    (item) => item.store_id,
                                  )
                          "
                        ></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-autocomplete>
                <v-btn depressed @click="selectStore = []">
                  ล้างสาขา
                </v-btn>
              </div>

              <!-- <v-select
                @change="onChangeStore"
                v-model="selectStore"
                :items="storeData"
                label="Select Store"
               item-text="store_name"
                item-value="store_id"
              ></v-select> -->
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" lg="8">
              <div class="ratio-condition-container">
                <v-checkbox
                  v-model="useRatioCondition"
                  label="กำหนดสัดส่วนการนับสินค้า (ของพนักงานคนหลัก)"
                  hide-details
                  class="my-0"
                ></v-checkbox>

                <template v-if="useRatioCondition">
                  <div class="heading-form mt-4">
                    สัดส่วนการนับสินค้า (ของพนักงานคนหลัก)
                  </div>
                  <v-row>
                    <v-col cols="12">
                      <v-slider
                        v-model="mainRatio"
                        class="align-center"
                        :max="100"
                        :min="1"
                        hide-details
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="mainRatio"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 60px"
                          >
                            <template v-slot:append> % </template>
                          </v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>

                  <div class="heading-form">เลือกตำแหน่ง</div>
                  <v-row>
                    <v-col cols="12">
                      <div class="select-container">
                        <v-autocomplete
                          v-model="filterPosition"
                          :items="positions"
                          label="ตำแหน่ง"
                          chips
                          small-chips
                          multiple
                          outlined
                          hide-details
                        >
                          <template
                            v-if="positions.length > 0"
                            v-slot:prepend-item
                          >
                            <v-list-item>
                              <v-list-item-title>
                                <v-checkbox
                                  :label="`เลือกตำแหน่งทั้งหมด (${positions.length} ตำแหน่ง)`"
                                  :value="
                                    filterPosition.length ===
                                    positions.length
                                  "
                                  :indeterminate="
                                    filterPosition.length > 0 &&
                                    filterPosition.length <
                                      positions.length
                                  "
                                  class="my-0"
                                  hide-details
                                  @click.stop="
                                    filterPosition =
                                      filterPosition.length ===
                                      positions.length
                                        ? []
                                        : positions.slice()
                                  "
                                ></v-checkbox>
                              </v-list-item-title>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                        <v-btn
                          color="grey"
                          dark
                          depressed
                          @click="filterPosition = []"
                        >
                          ล้างตำแหน่ง
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <div class="heading-form">เลือกแบรนด์</div>
          <v-row>
            <v-col cols="12" lg="8">
              <div class="select-container">
                <v-autocomplete
                  v-model="selectBrand"
                  :items="brands"
                  chips
                  label="แบรนด์"
                  multiple
                  outlined
                  small-chips
                  hide-details
                >
                  <template
                    v-if="brands.length > 0"
                    v-slot:prepend-item
                  >
                    <v-list-item>
                      <v-list-item-title>
                        <v-checkbox
                          :label="`เลือกแบรนด์ทั้งหมด (${brands.length} แบรนด์)`"
                          :value="
                            selectBrand.length === brands.length
                          "
                          :indeterminate="
                            selectBrand.length > 0 &&
                            selectBrand.length < brands.length
                          "
                          class="my-0"
                          hide-details
                          @click.stop="
                            selectBrand =
                              selectBrand.length === brands.length
                                ? []
                                : brands.slice()
                          "
                        ></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-autocomplete>
                <v-btn depressed @click="selectBrand = []">
                  ล้างแบรนด์
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <div class="heading-form">เลือกหมวดหมู่</div>
          <v-row align="center">
            <v-col cols="12" lg="8">
              <div class="select-container">
                <v-autocomplete
                  v-model="selectCategory"
                  :items="categories"
                  chips
                  label="หมวดหมู่"
                  multiple
                  outlined
                  small-chips
                  hide-details
                >
                  <template
                    v-if="categories.length > 0"
                    v-slot:prepend-item
                  >
                    <v-list-item>
                      <v-list-item-title>
                        <v-checkbox
                          :label="`เลือกหมวดหมู่ทั้งหมด (${categories.length} หมวดหมู่)`"
                          :value="
                            selectCategory.length ===
                            categories.length
                          "
                          :indeterminate="
                            selectCategory.length > 0 &&
                            selectCategory.length < categories.length
                          "
                          class="my-0"
                          hide-details
                          @click.stop="
                            selectCategory =
                              selectCategory.length ===
                              categories.length
                                ? []
                                : categories.slice()
                          "
                        ></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-autocomplete>
                <v-btn depressed @click="selectCategory = []">
                  ล้างหมวดหมู่
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <div class="heading-form">เลือกหมวดหมู่ย่อย</div>
          <v-row>
            <v-col cols="12" lg="8">
              <div class="select-container">
                <v-autocomplete
                  v-model="selectSubCategory"
                  :items="subCategories"
                  chips
                  label="หมวดหมู่ย่อย"
                  multiple
                  outlined
                  small-chips
                  hide-details
                >
                  <template
                    v-if="subCategories.length > 0"
                    v-slot:prepend-item
                  >
                    <v-list-item>
                      <v-list-item-title>
                        <v-checkbox
                          :label="`เลือกหมวดหมู่ย่อยทั้งหมด (${subCategories.length} หมวดหมู่ย่อย)`"
                          :value="
                            selectSubCategory.length ===
                            subCategories.length
                          "
                          :indeterminate="
                            selectSubCategory.length > 0 &&
                            selectSubCategory.length <
                              subCategories.length
                          "
                          class="my-0"
                          hide-details
                          @click.stop="
                            selectSubCategory =
                              selectSubCategory.length ===
                              subCategories.length
                                ? []
                                : subCategories.slice()
                          "
                        ></v-checkbox>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-autocomplete>
                <v-btn depressed @click="selectSubCategory = []">
                  ล้างหมวดหมู่ย่อย
                </v-btn>
              </div>
            </v-col>
            <!-- <v-col cols="2" v-for="item in subCategories" :key="item">
              <v-checkbox
                v-model="selectSubCategory"
                :label="item"
                color="blue"
                :value="item"
                hide-details
              ></v-checkbox>
            </v-col> -->
          </v-row>
          <div class="heading-form">โปรดักโค้ด (SKU)</div>
          <v-row>
            <v-col cols="12" lg="8">
              <v-combobox
                label="โปรดักโค้ด"
                v-model="skus"
                :delimiters="[',']"
                chips
                clearable
                multiple
                outlined
                append-icon=""
                placeholder="กรอก sku ตามด้วย ,(comma) เพื่อใส่ sku ต่อไป ex. sku1,sku2"
              >
                <template
                  v-slot:selection="{ attrs, item, select, selected }"
                >
                  <v-chip
                    small
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="removeSku(item)"
                  >
                    {{ item }}
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
          <WarnSection />
          <!-- Submit -->
          <v-btn color="primary" @click="submit"> บันทึก </v-btn>
          <!-- <v-btn @click="clear"> clear </v-btn> -->
        </v-container>
      </v-form>
    </v-card>
    <v-snackbar v-model="toastSuccess" :timeout="5000">
      บันทึกสำเร็จ
      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="toastSuccess = false"
        >
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout'
import WarnSection from '@/components/WarnSection'
// import InputDatePicker from '@/components/InputDatePicker'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      me: (state) => state.me.data,
      storeData: (state) => state.masterData.store,
      buData: (state) => state.masterData.bu,
      categoryData: (state) => state.masterData.category,
    }),
    dateRangeText() {
      return this.dates.join(` ~ `)
    },
    jobDateDisp() {
      return this.jobDateVal
      // format date, apply validations, etc. Example below.
      // return this.jobDateVal ? this.formatDate(this.jobDateVal) : "";
    },
    bu() {
      return this?.buData?.filter((i) => i?.bu_id !== 'all') ?? []
    },
    positions() {
      return this.categoryData?.positions ?? []
    },
    categories() {
      return (
        this.categoryData?.categories.map((i) => i?.category_name) ??
        []
      )
    },
    brands() {
      return this.categoryData?.brands ?? []
    },
    subCategories() {
      const all = this.categoryData?.categories.reduce(
        (subCat, i) => {
          subCat = [...subCat, ...i?.sub_cat]
          // console.log('1=>', subCat?.concat(i?.sub_cat))
          return subCat
        },
        [],
      )
      return (
        all?.filter(
          (value, index, self) => self?.indexOf(value) === index,
        ) ?? []
      )
      // TODO: Deprecate use sub cat all
      // const result = this?.categoryData?.categories?.reduce(
      //   (subCat, i) => {
      //     if (this.selectCategory?.includes(i.category_name)) {
      //       return subCat?.concat(i?.sub_cat)
      //     }
      //     return subCat
      //   },
      //   [],
      // )
      // // Filter duplicates
      // const filter = result?.filter(
      //   (value, index, self) => self?.indexOf(value) === index,
      // )
      // if (filter?.length > 0) {
      //   return result?.filter(
      //     (value, index, self) => self?.indexOf(value) === index,
      //   )
      // } else {
      //   return all?.filter(
      //     (value, index, self) => self?.indexOf(value) === index,
      //   )
    },
    hours() {
      let hh = []
      for (let i = 0; i < 24; i++) {
        i < 10 ? hh.push(`0${i}`) : hh.push(i)
      }
      return hh
    },
    minutes() {
      return ['00', '15', '30', '45']
    },
    hours2() {
      let hh = []
      for (let i = +this.fromHH + 1 ?? 0; i < 24; i++) {
        i < 10 ? hh.push(`0${i}`) : hh.push(i)
      }
      return hh
    },
    storeDataFilterByBuId() {
      const selections =
        this?.storeData?.filter((i) => i?.bu_id === this?.selectBU) ??
        this?.storeData ??
        []

      return selections
    },
  },

  components: {
    Layout,
    WarnSection,
    // InputDatePicker,
  },

  data() {
    return {
      toastSuccess: false,
      modal: false,
      selectBU: null,
      selectStore: [],
      jobName: '',
      jobDate: null,
      dates: [],
      menu1: false,
      menu2: false,
      selectCategory: [],
      selectSubCategory: [],
      selectBrand: [],
      fromHH: '',
      fromMM: '00',
      endHH: '',
      endMM: '00',
      skus: [],

      useRatioCondition: false,
      mainRatio: 1,
      filterPosition: [],
    }
  },

  mounted() {
    this.$store.dispatch('masterData/getBu')
    this.$store.dispatch('masterData/getStore')
    this.$store.dispatch('masterData/getCategory')
  },

  methods: {
    clear() {
      this.jobDate = ''
      this.jobName = ''
      this.dates = []
      this.selectBU = ''
    },
    onChangeBU() {
      this.getCategory()
      this.selectStore = []
      this.filterPosition = []
    },
    onChangeStore() {
      this.getCategory()
    },
    getCategory() {
      this.$store.dispatch('masterData/getCategory', {
        buId: this.selectBU,
      })
      // TODO: Delete Select Store choice storeId or buId
      // if (this.selectStore) {
      //   this.$store.dispatch('masterData/getCategory', {
      //     storeId: this.selectStore,
      //   })
      // } else {
      //   this.$store.dispatch('masterData/getCategory', {
      //     buId: this.selectBU,
      //   })
      // }
    },
    transformPayloadService() {
      return {
        bu_id: this.selectBU,
        'job_date[]': this.dates,
        job_name: this.jobName,
        start_time: `${this.fromHH}:${this.fromMM}`,
        end_time: `${this.endHH}:${this.endMM}`,
        'store_ids[]': this?.selectStore?.filter(
          (s) =>
            this?.storeDataFilterByBuId?.find(
              (i) => i?.store_id === s,
            )?.bu_id === this.selectBU,
        ),
        'product_brands[]': this.selectBrand,
        'categories[]': this.selectCategory,
        'sub_cats[]': this.selectSubCategory,
        sku: this.skus,

        ...(this.useRatioCondition
          ? {
              main_ratio: this.mainRatio || 1,
              filter_position: this.filterPosition.join(','),
            }
          : {}),
      }
    },
    submit() {
      const payload = this.transformPayloadService()

      try {
        this.$store.dispatch('job/createJob', payload)
      } catch (error) {
        console.error('Create Job Error: ', error)
      }
    },
    remove(id) {
      let idx = this.dates.indexOf(id)
      this.dates.splice(idx, 1)
      this.dates = [...this.dates]
    },
    removeSku(val) {
      this.skus = this.skus.filter((i) => i !== val)
    },
  },
}
</script>

<style lang="stylus" scoped>
.v-list-item__title {
  text-align: left !important;
}
</style>
